import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import withTranslations from '../../utils/HighOrderComponent';
import { confirmDialog } from '../Reusable/ConfirmDialog';
import ModalForUpdateRole from './ModalForUpdateRole';

class RoleRow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
    };
  }

  onDeleteClick = (id) => {
    const translation = this.props.t.ConfirmDialog;
    const action = () => {
      this.props.deleteRole(id);
    };
    confirmDialog(
      translation.confirmMessage,
      action,
      translation.confirmDelete,
      this.props.gt
    );
  };

    showModalUpdate = () => {
      this.setState({ show: true });
    };
    
  handlePreviewClose = () => {
    this.setState({ show: false });
    //this.props.deleteError();
  };

  handleEdit = (role) => {
    this.props.updateRole(role, this.handlePreviewClose);
  };

  render() {
    const { role, index } = this.props || {},
      { roleName, id } = role || {};

    let row = (
      <tr>
        <td>{index}</td>
        <td>{roleName}</td>

        <td className="text-center">
          <Link
            onClick={(e) => {
              this.showModalUpdate();
            }}
          >
            <i className="fas fa-edit fa-2x" />
          </Link>
        </td>
        <td className="text-center">
          <Link id="deleteUser" onClick={() => this.onDeleteClick(id)}>
            <i className="fas fa-trash-alt fa-2x" />
          </Link>
        </td>
      </tr>
    );

    return (
      <Fragment>
        {row}
        {this.state.show && (
          <ModalForUpdateRole
            show={this.state.show}
            role={this.props.role}
            handleEdit={this.handleEdit}
            handleClose={this.handlePreviewClose}
            actionList={this.props.actionList}
            error={this.props.error}
            deleteError={this.props.deleteError}
          />
        )}
      </Fragment>
    );
  }
}

export default withTranslations(RoleRow, 'RoleRow');